import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'react-tippy';
import { css } from 'emotion'

import { tooltipStyle } from './style'

const TooltipOffers = (props) => {
  const { children, color, content } = props

  return(
    <div className={css`${tooltipStyle(color)}`}>
      <Tooltip
        arrow={true}
        html={content}
        theme='custom-tooltip'
        {...props}
      >
        {children ? children : (
          <div className="icon-default">
            <p>?</p>
          </div>
        )}
      </Tooltip>
    </div>
  )
}

TooltipOffers.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  content: PropTypes.any.isRequired
}

TooltipOffers.defaultProps = {
  color: '#2b82b2',
}

export default TooltipOffers